export default __webpack_public_path__ + "static/media/rest-li.98c1114c.svg";